import { Badge, Menu, Portal } from '@chakra-ui/react';

export function StatusMenu({ isActive, onStatusChange }: {
  isActive: boolean
  onStatusChange: (active: boolean) => void
}) {
  return (
    <Menu.Root>
      <Menu.Trigger asChild><Badge
          colorPalette={isActive ? 'green' : 'gray'}
          fontSize="xs"
          cursor="pointer"
          _hover={{ opacity: 0.7 }}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          {isActive ? 'Active' : 'Inactive'}
        </Badge></Menu.Trigger>
      <Portal><Menu.Positioner><Menu.Content>
            <Menu.Item
              fontSize="sm"
              onSelect={() => onStatusChange(true)}
              disabled={isActive}
              value='item-0'>Active</Menu.Item>
            <Menu.Item
              fontSize="sm"
              onSelect={() => onStatusChange(false)}
              disabled={!isActive}
              value='item-1'>Inactive</Menu.Item>
          </Menu.Content></Menu.Positioner></Portal>
    </Menu.Root>
  );
}
